import { render, staticRenderFns } from "./TableMergeCheckbox.vue?vue&type=template&id=3725553b&scoped=true&"
import script from "./TableMergeCheckbox.vue?vue&type=script&lang=js&"
export * from "./TableMergeCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TableMergeCheckbox.vue?vue&type=style&index=0&id=3725553b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3725553b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
